export const getDropDate = (year, month, day) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const formattedDate = `${day.toString().padStart(2, '0')} ${months[month - 1]} ${year % 100}`;
    // const formattedDate = `${day.toString().padStart(2, '0')}-${months[month - 1]}-${year} ${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}`;
    return formattedDate
}

export const getDropTime = (hour, minute, second) => {
    const formattedDate = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}`;
    return formattedDate
}
